<template>
  <div class="workspace app-container">
    <div class="toolbar">
      <el-form :inline="true" :model="queryParams4" size="mini" label-width="60px">
        <el-form-item label="发起时间" prop="workTimevalue" label-width="70px">
          <el-date-picker
            v-model="workTimevalue"
            type="daterange"
            align="center"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="分组" prop="tptGroupId">
          <el-select
            style="width: 100%"
            filterable
            clearable
            v-model="queryParams4.tptGroupId"
            placeholder="请选择分组"
            @change="getTpt"
          >
            <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板" prop="tptId">
          <el-select style="width: 100%" filterable clearable v-model="queryParams4.tptId" placeholder="请选择模板">
            <el-option v-for="item in options2" :key="item.tptId" :label="item.name" :value="item.tptId"> </el-option>
          </el-select>
        </el-form-item>
         <el-form-item label="提报人" prop="customName" label-width="70px">
          <el-input
            v-model="queryParams4.applyMan"
            placeholder="请输入提报人"
          />
        </el-form-item>

        <el-form-item label="状态" prop="state" class="radioMargin" label-width="70px">
          <el-radio-group v-model="queryParams4.status">
            <el-radio :label="undefined" border>全部</el-radio>
            <el-radio :label="2" border>流转中</el-radio>
            <el-radio :label="9" border>结束</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="结果" prop="result" class="radioMargin">
          <el-radio-group v-model="queryParams4.result">
            <el-radio :label="undefined" border>全部</el-radio>
            <el-radio :label="1" border>审核中</el-radio>
            <el-radio :label="2" border>完成</el-radio>
            <!-- <el-radio :label="3" border>撤回</el-radio> -->
            <el-radio :label="4" border>拒绝</el-radio>
            <!-- <el-radio :label="5" border>退回</el-radio> -->
          </el-radio-group>
        </el-form-item>
        <el-form-item style="margin-left: 20px">
          <el-button icon="fa fa-search" type="primary" @click="handleFilter(1)">查询</el-button>
          <el-button type="warning" plain icon="el-icon-download" size="mini" @click="handleExport">导出</el-button>
          <el-button type="warning" plain icon="el-icon-download" size="mini" @click="handleExportTxt">导出文件</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-list">
      <div class="addToolbar">
        <el-form :inline="true" size="mini" style="float: right">
          <el-form-item>
            <el-button-group>
              <el-tooltip content="刷新" placement="top">
                <el-button icon="fa el-icon-refresh" @click="handleFilter(queryParams4.pageNum)" />
              </el-tooltip>
            </el-button-group>
          </el-form-item>
        </el-form>
      </div>
      <el-table v-loading="tableData4Loading" :data="tableData4.list" style="width: 100%" height="534">
        <el-table-column prop="customName" label="流程名称" width="160" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="tptName" label="模板" width="160" show-overflow-tooltip />
        <el-table-column prop="tptGroupName" label="分组" width="160" show-overflow-tooltip />
        <el-table-column prop="applyTime" label="发起时间" width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ parseTime(scope.row.applyTime) }}
          </template>
        </el-table-column>

        <el-table-column prop="applyMan" label="发起人" width="150" show-overflow-tooltip />
        <el-table-column prop="totalAmount" label="金额" width="150" show-overflow-tooltip />
        <el-table-column label="状态" align="center" prop="StatusDesc">
          <template slot-scope="{ row }">
            <span style="color: #67c23a" v-if="row.status == 2" type="warning" size="small">流转中</span>
            <span v-if="row.status == 9" type="small" size="small">结束</span>
          </template>
        </el-table-column>
        <el-table-column label="结果" align="center" prop="result" fixed="right">
          <template slot-scope="{ row }">
            <el-tag v-if="row.result == 1" size="small">审核中</el-tag>
            <el-tag v-if="row.result == 2" type="success" size="small">完成</el-tag>
            <el-tag v-if="row.result == 3" type="success" size="small">撤回</el-tag>
            <el-tag v-if="row.result == 4" type="warning" size="small">拒绝</el-tag>
            <el-tag v-if="row.result == 5" type="warning" size="small">退回</el-tag>
          </template>
        </el-table-column>
<!--        <el-table-column prop="applyMan" label="备注" width="150" show-overflow-tooltip />-->
        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button icon="el-icon-search" circle size="mini" @click="handleSuccess2(scope.row)"></el-button>
            <el-button type="danger" size="mini" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="toolbar" style="padding: 10px">
        <pagination
          v-show="total4 > 0"
          :total="total4"
          :page.sync="queryParams4.pageNum"
          :limit.sync="queryParams4.pageSize"
          @pagination="getMyFlowInstancePage4"
        />
      </div>
    </div>
    <!-- 发起审批 -->
    <el-drawer title="发起审批" size="40%" :visible.sync="openItemDl" append-to-body class="editdrawer spDrawer">
      <initiate-process ref="processForm" :code="selectForm.tptId" v-if="openItemDl"></initiate-process>
      <div class="demo-drawer__footer" style="text-align: center; margin: 30px 0 20px">
        <el-button @click="openItemDl = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">提 交</el-button>
      </div>
    </el-drawer>

    <!-- 审批弹窗 -->
    <el-drawer
      title="审批详情"
      :visible.sync="drawer"
      destroy-on-close
      class="shenpi"
      size="35%"
      append-to-body
      @close="cancel"
    >
      <el-descriptions class="title" :column="2">
        <el-descriptions-item label="流程名称">
          {{ shenPiList.customName }}
        </el-descriptions-item>
        <el-descriptions-item label="模板名称">
          {{ shenPiList.tptName }}
        </el-descriptions-item>
        <el-descriptions-item label="模板分组">
          {{ shenPiList.tptGroupName }}
        </el-descriptions-item>
        <el-descriptions-item label="发起人">
          {{ shenPiList.applyMan }}
        </el-descriptions-item>
        <el-descriptions-item label="发起时间">
          {{ shenPiList.applyTime }}
        </el-descriptions-item>
        <!-- <el-descriptions-item label="当前节点">
          <el-tag size="small">{{ shenPiList.ActiviteName }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="节点类型">
          {{ shenPiList.ActiviteTypeDesc }}
        </el-descriptions-item> -->
      </el-descriptions>

      <div class="form" v-if="Show">
        <initiate-process1
          ref="processForm"
          :code="shenPiList.tptId"
          :flag="flag"
          :forms="formData"
          :formPerms="JSON.parse(shenPiList.formPerms)"
        ></initiate-process1>
      </div>

      <div class="form" v-if="!buttonShow">
        <el-timeline style="margin: 20px 0">
          <el-timeline-item v-for="(i, index) in processList" :key="index" :timestamp="i.addTime">
            {{ i.content }}
            <a v-if="i.attacth" :href="i.attacth">点击下载附件</a>
          </el-timeline-item>
        </el-timeline>
      </div>
      <div class="form" v-if="buttonShow">
        <div style="margin-top: 10px">审批</div>
        <el-form
          ref="dataForm"
          :model="dataForm"
          label-width="120px"
          :rules="dataFormRules"
          label-position="right"
          class="demo-form-inline"
          :inline="true"
          size="mini"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="审批意见" prop="verifyIdea">
                <el-input
                  v-model="dataForm.verifyIdea"
                  type="textarea"
                  autosize
                  style="width: 252px"
                  auto-complete="off"
                  placeholder="请输入审批意见"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="附件" prop="attacth">
                <file-upload v-model="dataForm.attacth" :isShowTip="false" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="demo-drawer__footer" style="text-align: center; margin: 60px 0 20px" v-if="buttonShow">
          <!-- <el-button @click.native="cancel">关闭</el-button> -->
          <el-button :loading="editLoading" type="success" @click.native="ceasepost(1)">同意</el-button>
          <el-button :loading="editLoading" type="warning" @click.native="ceasepost(2)">不同意</el-button>
          <!-- <el-button
            :loading="editLoading"
            type="danger"
            @click.native="ceasepost(3)"
            >驳回</el-button
          > -->
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  getFormGroups,
  SubmitInstance,
  GetMyFlowInstancePage,
  GetFlowInstancePage,
  GetFlowInstance,
  VerifyInstance,
  GetOpeateRecList,
  DeleteInstance,
} from '@/api/design'
import InitiateProcess1 from './InitiateProcess1'
import InitiateProcess from './InitiateProcess'
import { GetGlobalTptGroupoPage, GetTptList } from '@/api/Industry'
export default {
  name: 'workSpace',
  components: { InitiateProcess1, InitiateProcess },
  data() {
    return {
      flag: '',
      delet: false,
      options1: [],
      options2: [],
      workTimevalue: [],
      processList: [],
      queryParams4: {
        flag:0,
        userId: this.$route.query.userId,
        platformId: this.$route.query.platformId,
        companyId: this.$route.query.EId,
        pageNum: 1,
        pageSize: 10,
        result: undefined,
        status: undefined,
        // customName: "",
        teamId: '',
        tptId: '',
        tptGroupId: '',
        applyMan:''
      },
      queryParams3: {
        pageNum: 1,
        pageSize: 10,
        flag: '', //1-待我处理、2-关于我的、3-我发起的、4-抄送给我
      },
      queryParams2: {
        pageNum: 1,
        pageSize: 10,
        flag: '', //1-待我处理、2-关于我的、3-我发起的、4-抄送给我
      },
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        flag: '', //1-待我处理、2-关于我的、3-我发起的、4-抄送给我
      },
      total: 0,
      total2: 0,
      total3: 0,
      total4: 0,
      instanceId: '',
      ActiviteId: '',
      editLoading: false,
      dataForm: {},
      dataFormRules: {
        Status: [{ required: true, message: '审核结果不能为空', trigger: 'change' }],
      },
      activities: [],
      Show: false,
      formData: [],
      shenPiList: {}, // 审批详情
      drawer: false,
      activeName: '审批列表',
      buttonShow: true,
      tableData: {},
      tableData2: {},
      tableData3: {},
      tableData4: {},
      loading: false,
      tableDataLoading: false,
      tableData2Loading: false,
      tableData3Loading: false,
      tableData4Loading: false,
      tptId: '',
      openItemDl: false,
      selectForm: {},
      formItem: {},
      actives: [],
      formList: {
        list: [],
        name: '',
        searchResult: [],
      },
      pending: {
        list: [],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
    }
  },
  mounted() {
    // this.getGroups();
    this.getMyFlowInstancePage4()
    this.getTptGroupoList()
  },
  methods: {
    // 获取分组列表
    getTptGroupoList() {
      GetGlobalTptGroupoPage({
        companyId: this.$route.query.EId,
        platformId: this.$route.query.platformId,
      }).then((res) => {
        if (res.code === 200) {
          this.options1 = res.data
        }
      })
    },
    // 获取模板列表
    getTptList(val) {
      GetTptList({
        groupId: val,
        companyId: this.$route.query.EId,
        platformId: this.$route.query.platformId,
      }).then((res) => {
        if (res.code === 200) {
          this.options2 = res.data
        }
      })
    },

    getTpt(val) {
      console.log(val)
      this.getTptList(val)
    },
    // 审批
    handleSuccess(row) {
      console.log(row)
      this.ActiviteId = row.ActiviteId
      this.instanceId = row.instanceId
      this.drawer = true
      this.buttonShow = true
      GetFlowInstance({ instanceId: row.instanceId }).then((res) => {
        this.shenPiList = res.data
        this.formData = JSON.parse(this.shenPiList.formData)
        // this.formData = eval("(" + this.shenPiList.formData + ")");
        if (this.formData) {
          this.Show = true
        }
      })
    },
    handleSuccess2(row) {
      this.drawer = true
      this.buttonShow = false
      GetFlowInstance({ instanceId: row.instanceId }).then((res) => {
        this.shenPiList = res.data
        console.log(this.shenPiList.formData.length, 'length')
        this.formData = JSON.parse(this.shenPiList.formData)
        if (this.shenPiList.formData.length > 4) {
          this.Show = true
        } else {
          this.Show = false
        }
      })
      GetOpeateRecList({ instanceId: row.instanceId }).then((res) => {
        this.processList = res.data
      })
    },
    ceasepost(val) {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.dataForm.instanceId = this.instanceId
          this.dataForm.ActiviteId = this.ActiviteId
          this.dataForm.verifyFlag = val
          this.formData.forEach((i) => {
            i.value = this.$store.state.formValue[i.id]
          })
          this.dataForm.formData = JSON.stringify(this.formData)
          console.log(this.dataForm, 'dataForm')
          this.editLoading = true
          VerifyInstance(this.dataForm).then((res) => {
            this.editLoading = false
            if (res.code === 200) {
              this.$message({ message: '操作成功', type: 'success' })
              this.getMyFlowInstancePage()
              this.$refs['dataForm'].resetFields()
              this.cancel()
            } else {
              this.$message({ message: '操作失败, ' + res.msg, type: 'error' })
            }
          })
        }
      })
    },
    cancel() {
      this.drawer = false
      this.shenPiList = {}
      this.Show = false
      this.dataForm = {
        instanceId: null,
        verifyFlag: null,
        ActiviteId: null,
        verifyIdea: null,
        attacth: null,
      }
    },
    handleClick(tab) {
      console.log(tab)
      if (tab.name == '待我处理') {
        this.queryParams.flag = 1
        this.flag = 1
        this.tableDataLoading = true
        this.getMyFlowInstancePage()
      }
      if (tab.name == '我处理的') {
        this.tableData2Loading = true
        this.queryParams2.flag = 2
        this.flag = 2
        this.getMyFlowInstancePage2()
      }
      if (tab.name == '我发起的') {
        this.tableData3Loading = true
        this.queryParams3.flag = 3
        this.flag = 3
        this.getMyFlowInstancePage3()
      }
      if (tab.name == '抄送给我') {
        this.tableData4Loading = true
        this.queryParams4.flag = 4
        this.flag = 4
        this.getMyFlowInstancePage4()
      }
    },
    // 获取待我处理 列表
    async getMyFlowInstancePage() {
      const res = await GetMyFlowInstancePage(this.queryParams)
      this.tableData = res
      this.total = res.count
      this.tableDataLoading = false
    },
    // 获取待我处理 列表
    async getMyFlowInstancePage2() {
      const res = await GetMyFlowInstancePage(this.queryParams2)
      this.tableData2 = res
      this.total2 = res.count
      this.tableData2Loading = false
    },
    async getMyFlowInstancePage3() {
      const res = await GetMyFlowInstancePage(this.queryParams3)
      this.tableData3 = res
      this.total3 = res.count
      this.tableData3Loading = false
    },
    async getMyFlowInstancePage4() {
      if (this.workTimevalue == null) {
        this.queryParams4.endApplyTime = undefined
        this.queryParams4.startApplyTime = undefined
      } else {
        this.queryParams4.endApplyTime = this.workTimevalue[1]
        this.queryParams4.startApplyTime = this.workTimevalue[0]
      }
      const res = await GetFlowInstancePage(this.queryParams4)
      console.log(res.data, 'res')
      this.tableData4 = res.data
      this.total4 = res.data.total
      console.log(this.total4, ' this.total4')
      this.tableData4Loading = false
    },
    // 查询
    handleFilter(val) {
      this.tableData4Loading = true
      this.queryParams4.pageNum = val
      this.getMyFlowInstancePage4()
    },
    getSearch() {
      clearTimeout(this.timer)
      this.loading = true
      this.timer = setTimeout(() => {
        this.getGroups()
      }, 1000)
    },
    getGroups() {
      this.loading = true
      getFormGroups({ name: this.formList.name })
        .then((rsp) => {
          this.formList.list = rsp.data
          this.formList.list.forEach((group) => {
            this.actives.push(group.Name)
            group.TptList.forEach((item) => {
              item.Icon = JSON.parse(item.Icon)
            })
          })
          this.groups = rsp.data
          this.loading = false
        })
        .catch((err) => this.$message.error('获取分组异常'))
    },
    enterItem(item) {
      console.log(item.tptId) // 模板id
      this.tptId = item.tptId
      this.selectForm = item
      this.openItemDl = true
    },
    // 删除
    handleDelete(row) {
      this.$confirm('确认要删除此项吗？', '提示', {}).then(() => {
        this.editLoading = true
        DeleteInstance({ instanceId: row.instanceId }).then((res) => {
          if (res.code === 200) {
            this.$message({ message: '删除成功', type: 'success' })
            this.getMyFlowInstancePage4()
          } else {
            this.$message({ message: '删除失败, ' + res.msg, type: 'error' })
          }
        })
      })
    },
    submitForm() {
      this.$refs.processForm.validate((valid) => {
        if (valid) {
          console.log(this.$store.state.formValue)
          var formItems = this.$store.state.design.formItems
          console.log(formItems, 'formItems')
          for (let i = 0; i < formItems.length; i++) {
            const e = formItems[i]
            e.value = this.$store.state.formValue[e.id]
          }
          console.log(this.$store.state.design.formItems)
          // return;
          SubmitInstance({
            tptId: this.tptId,
            formData: JSON.stringify(this.$store.state.design.formItems),
          }).then((res) => {
            if (res.code === 200) {
              this.$message({ message: '审批成功', type: 'success' })
              this.openItemDl = false
              this.$refs['processForm'].resetFields()
              this.getGroups()
            } else {
              this.$message({ message: '操作失败, ' + res.msg, type: 'error' })
            }
          })
        } else {
          this.$message.warning('请完善表单😥')
        }
      })
    },
    handleExportTxt(){
      if (this.workTimevalue == null) {
        this.queryParams4.endApplyTime = undefined
        this.queryParams4.startApplyTime = undefined
      } else {
        this.queryParams4.endApplyTime = this.workTimevalue[1]
        this.queryParams4.startApplyTime = this.workTimevalue[0]
      }
      var params = this.queryParams4
      this.downloadData(
          'OA/approvalInstance/exportFile',
          {
            ...params,
          },
          `审批记录文件_${new Date().getTime()}.zip`
      )
    },
    /** 导出按钮操作 */
    handleExport() {
      if (this.workTimevalue == null) {
        this.queryParams4.endApplyTime = undefined
        this.queryParams4.startApplyTime = undefined
      } else {
        this.queryParams4.endApplyTime = this.workTimevalue[1]
        this.queryParams4.startApplyTime = this.workTimevalue[0]
      }
      var params = this.queryParams4
      this.downloadData(
        'OA/approvalInstance/export',
        {
          ...params,
        },
        `审批记录_${new Date().getTime()}.xlsx`
      )
    },
  },
}
</script>

<style lang="less" scoped>
.workspace {
  // padding: 15px 0px;
  position: relative;

  .back {
    position: absolute;
    left: 20px;
    top: 13px;
  }

  .no-data {
    text-align: center;
    padding: 50px 0;
    color: #656565;
    margin: 0 auto;
  }

  /deep/ .el-collapse {
    padding: 0 15px;
    background: #ffffff;

    .el-collapse-item__header {
      font-size: medium;
    }

    .el-collapse-item__wrap {
      padding: 20px 10px;
    }

    .el-tabs--border-card .el-tabs__content {
      padding: 40px 15px;
    }
  }

  .form-item {
    padding: 15px 10px;
    width: 222px;
    cursor: pointer;
    border: 1px solid #d9dada;
    border-radius: 5px;
    float: left;
    margin: 5px 10px;
    height: 69px;

    &:hover {
      border: 1px solid #448ed7;

      span {
        display: inline-block !important;
      }
    }

    i {
      padding: 8px;
      border-radius: 8px;
      float: left;
      font-size: 20px;
      color: #ffffff;
      background: #38adff;
      height: 36px;
      //   line-height: 28px;
    }

    div {
      height: 35px;
      line-height: 35px;

      div {
        display: inline-block;
        margin-left: 10px;
        width: 100px;
      }

      span {
        display: none;
        float: right;
        color: #38adff;
        font-size: 12px;
      }
    }

    /*span:nth-child(1) {
          float: left;
          margin: 5px 0 0 10px;
        }*/
    /*span:nth-child(1) {
          float: right;
          color: #448ed7;
          font-size: x-small;
          margin: 5px 0 5px 0;
        }*/
  }
}

@media screen and (max-width: 800px) {
  .form-item {
    padding: 12px 10px !important;
    width: 150px !important;
    margin: 5px !important;

    &:hover {
      span:last-child {
        display: none !important;
      }
    }
  }
}
.icon {
  display: block;
  width: 33px;
  height: 33px;
  vertical-align: middle;
  margin-right: 10px;
  border-radius: 10px;
}

.spDrawer /deep/ .el-input {
  width: 100% !important;
}
.shenpi /deep/ .el-drawer__body {
  background-color: #eee;
}
.shenpi /deep/ .el-drawer__body {
  padding: 0;
}

.shenpi /deep/ .el-drawer__header {
  margin-bottom: 32px;
}
.shenpi .title {
  padding: 0 25px;
  background: #ffffff;
}

.shenpi .form {
  margin-top: 15px;
  background: #fff;
  padding: 10px 25px;
}
.el-timeline-item {
  padding-bottom: 50px;
}

/deep/ .el-timeline-item__tail {
  border-left: 2px solid #397affbf;
}
/deep/ .el-timeline-item__node {
  background-color: #397aff;
}

/deep/ .el-radio {
  margin-right: 0;
}
</style>
